import { c as _c } from "react/compiler-runtime";
import ThumbDown from "@mui/icons-material/ThumbDown";
import ThumbDownOutlined from "@mui/icons-material/ThumbDownOutlined";
import ThumbUp from "@mui/icons-material/ThumbUp";
import ThumbUpOutlined from "@mui/icons-material/ThumbUpOutlined";
import { Box, Button, ButtonGroup, useTheme } from "@mui/material";
import React, { useMemo } from "react";
import type { QuestionDataQuery } from "#/graphql/generated";
interface RatingButtonsProps {
  question: QuestionDataQuery["question"];
  onLike?: () => void;
  onDislike?: () => void;
}
export const RatingButtons: React.FC<RatingButtonsProps> = t0 => {
  const $ = _c(29);
  const {
    question,
    onLike,
    onDislike
  } = t0;
  const theme = useTheme();
  const likesPercentage = question.likes / (question.likes + question.dislikes) * 100;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      position: "relative"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = likesPercentage > 50 ? "success" : "error";
  let t3;
  if ($[1] !== question.isLiked) {
    t3 = question.isLiked ? <ThumbUp /> : <ThumbUpOutlined />;
    $[1] = question.isLiked;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onLike || $[4] !== question.likes || $[5] !== t3) {
    t4 = <Button startIcon={t3} color="success" onClick={onLike} aria-label="Like">{question.likes}</Button>;
    $[3] = onLike;
    $[4] = question.likes;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== question.isLiked) {
    t5 = question.isLiked === false ? <ThumbDown /> : <ThumbDownOutlined />;
    $[7] = question.isLiked;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onDislike || $[10] !== question.dislikes || $[11] !== t5) {
    t6 = <Button startIcon={t5} color="error" onClick={onDislike} aria-label="Dislike">{question.dislikes}</Button>;
    $[9] = onDislike;
    $[10] = question.dislikes;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t4 || $[15] !== t6) {
    t7 = <ButtonGroup variant="text" color={t2}>{t4}{t6}</ButtonGroup>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== theme.palette.error.dark || $[18] !== theme.shape.borderRadius) {
    t8 = {
      height: "4px",
      width: "100%",
      marginTop: "1px",
      borderRadius: theme.shape.borderRadius,
      background: theme.palette.error.dark,
      overflow: "hidden"
    };
    $[17] = theme.palette.error.dark;
    $[18] = theme.shape.borderRadius;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const t9 = `${likesPercentage}%`;
  let t10;
  if ($[20] !== t9 || $[21] !== theme.palette.success.main) {
    t10 = <Box sx={{
      height: "100%",
      transition: "0.3s width",
      width: t9,
      background: theme.palette.success.main
    }} />;
    $[20] = t9;
    $[21] = theme.palette.success.main;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t8) {
    t11 = <Box sx={t8}>{t10}</Box>;
    $[23] = t10;
    $[24] = t8;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t7) {
    t12 = <Box sx={t1}>{t7}{t11}</Box>;
    $[26] = t11;
    $[27] = t7;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};